import Phase10OrderPage from './Phase10OrderPage';

export default function SiteBoostOrderPage() {
  return <Phase10OrderPage skuCode="site-boost" />;
}
